<template>
  <div id="prescriber">
    <h2 class="text-center">{{ $t('pages.memorial.new.title') }}</h2>
    <p class="text-center"><i>{{ $t('pages.memorial.new.text') }}</i></p>
    <b-container>
      <ajax-new :name="name" :uri="uri" :config="{ headers: { 'Content-Language': $translation.getLocale() } }" />
    </b-container>
  </div>
</template>

<script>
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';

  export default {
    name: 'MemorialNew',
    components: {
      AjaxNew,
    },
    data() {
      return {
        name: 'memorial',
        uri: 'api/memorial',
      };
    },
    mounted() {
      if (!this.user().memorial) {
        this.$bus.$once(`t-event.new-submit.${this.name}.success`, () => {
          this.$ajax.refresh().then(() => {
            this.$parent.step += 1;
          });
        });
      }
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Memorial/new.vue